import { LOGIN_USER, LOGIN_SUCCESS, LOGOUT_USER, LOGOUT_USER_SUCCESS, API_ERROR, CHECK_END, LOGIN_INWEBO } from './actionTypes';

export const loginUser = (user, history, recaptcha) => {
    return {
        type: LOGIN_USER,
        payload: { user, history, recaptcha }
    }
}

export const loginInwebo = (user, history, recaptcha) => {
    return {
        type: LOGIN_INWEBO,
        payload: { user, history, recaptcha }
    }
}

export const loginSuccess = (user) => {
    return {
        type: LOGIN_SUCCESS,
        payload: user
    }
}

export const logoutUser = (history) => {
    return {
        type: LOGOUT_USER,
        payload: { history }
    }
}

export const checkEndUser = (history) => {
    return {
        type: CHECK_END,
        payload: { history }
    }
}

export const logoutUserSuccess = () => {
    return {
        type: LOGOUT_USER_SUCCESS,
        payload: {}
    }
}

export const apiError = (error) => {
    return {
        type: API_ERROR,
        payload: error
    }
}
